var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHangInSmallIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 81.986,
    height: 81.798,
    viewBox: "0 0 81.986 81.798",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_4",
    "data-name": 4,
    transform: "translate(-483.007 -24)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1995",
    "data-name": "Path 1995",
    d: "M519.161,105.777a1.51,1.51,0,0,1-.307-.021,41.043,41.043,0,1,1,26.495-75.8,2.386,2.386,0,1,1-2.47,4.082,36.274,36.274,0,1,0-23.421,66.986,2.39,2.39,0,0,1-.3,4.76Z",
    fill: "#c7c8c7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1996",
    "data-name": "Path 1996",
    d: "M559.811,52.722a2.39,2.39,0,0,1-2.2-1.474c-.191-.456-.382-.912-.594-1.368a2.388,2.388,0,1,1,4.336-2c.234.509.467,1.028.679,1.548a2.391,2.391,0,0,1-1.294,3.117,2.476,2.476,0,0,1-.9.18Z",
    fill: "#c7c8c7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1997",
    "data-name": "Path 1997",
    d: "M539.2,103.01a2.386,2.386,0,0,1-.933-4.581c.869-.371,1.728-.774,2.555-1.209a2.388,2.388,0,0,1,2.216,4.23c-.944.488-1.908.954-2.894,1.368a2.456,2.456,0,0,1-.933.191Zm10.178-6.373a2.348,2.348,0,0,1-1.8-.827,2.383,2.383,0,0,1,.244-3.361c.71-.615,1.4-1.262,2.067-1.93a2.384,2.384,0,1,1,3.393,3.35c-.742.753-1.527,1.495-2.332,2.184a2.36,2.36,0,0,1-1.559.583Zm7.74-9.171a2.416,2.416,0,0,1-1.24-.35,2.381,2.381,0,0,1-.795-3.276c.487-.8.943-1.633,1.367-2.47a2.383,2.383,0,0,1,4.252,2.152c-.477.954-1.007,1.9-1.559,2.8a2.361,2.361,0,0,1-2.035,1.145Zm4.559-11.1a2.443,2.443,0,0,1-.551-.064,2.386,2.386,0,0,1-1.771-2.873q.318-1.352.541-2.767a2.387,2.387,0,1,1,4.718.732c-.17,1.06-.371,2.12-.615,3.138A2.4,2.4,0,0,1,561.677,76.366ZM562.6,64.4a2.388,2.388,0,0,1-2.375-2.195c-.075-.944-.181-1.887-.329-2.81a2.387,2.387,0,1,1,4.718-.732c.159,1.039.286,2.11.371,3.17a2.387,2.387,0,0,1-2.2,2.566Z",
    fill: "#c7c8c7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1998",
    "data-name": "Path 1998",
    d: "M528.937,105.787a2.384,2.384,0,0,1-.3-4.749c.5-.064.986-.138,1.474-.213a2.386,2.386,0,0,1,.784,4.708c-.551.1-1.113.17-1.664.244-.106.01-.2.021-.308.021Z",
    fill: "#c7c8c7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1999",
    "data-name": "Path 1999",
    d: "M556.408,39.861l-4.824-12.055a1.93,1.93,0,0,0-3.308-.477l-8.037,10.21a1.93,1.93,0,0,0,1.241,3.107L554.33,42.5a1.931,1.931,0,0,0,2.067-2.63Z",
    fill: "#c7c8c7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2000",
    "data-name": "Path 2000",
    d: "M523.88,40.052a24.842,24.842,0,1,0,24.841,24.842A24.842,24.842,0,0,0,523.88,40.052ZM536.1,78.423a3.156,3.156,0,0,1-2.216.9,3.207,3.207,0,0,1-2.279-.965L521.6,68.064a3.2,3.2,0,0,1-.9-2.216V50.178a3.181,3.181,0,1,1,6.361,0V64.554l9.108,9.362a3.181,3.181,0,0,1-.064,4.5Z",
    fill: "#c7c8c7"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHangInSmallIcon);
export default __webpack_public_path__ + "static/media/hang-in-small-icon.c9bde4aa.svg";
export { ForwardRef as ReactComponent };